module.exports = __webpack_public_path__ + "static/img/cj0.719902f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/cj0.jpg
// module id = Jv//
// module chunks = 0